<template>
    <div class="w-100 block-container" :class="[color, id !== 0 ? 'block-top' : '']">
        <b-container fluid="" class="max-width">
            <div class="row justify-content-center">
                <div class="col-12 col-md-10 col-lg-8" v-if="parseComponent !== '' && data">
                    <block-header
                        :overline="data.OverlineTitleSection"
                        :title="data.TitleSection"
                        :subtitle="data.subTitleSection"
                        v-if="type !== 'text_with_dx_image'"
                    />
                    <component
                        v-bind:is="parseComponent"
                        :header="{overline: data.OverlineTitleSection, title: data.TitleSection, subTitle: data.subTitleSection}"
                        :columns="[
                            {
                                img: data.img_col_1,
                                text: data.text_col_1,
                                title: data.title_col_1,
                                buttonText: data.btn_text_col_1,
                                buttonHref: data.btn_url_col_1
                            },
                            {
                                img: data.img_col_2,
                                text: data.text_col_2,
                                title: data.title_col_2,
                                buttonText: data.btn_text_col_2,
                                buttonHref: data.btn_url_col_2
                            }
                        ]"
                        :text="data.Text"
                        :video-id="data.id_video"
                        :quotes="data.quote ? transformQuoteData(data.quote.data) : null"
                        :accordions="data.accordion ? data.accordion.data : null"
                        :quote-image="data.srcImg"
                        :quote-text="data.Text"
                        :quote-name="data.TitleSection"
                        :quote-detail="data.RoleSection"
                        :image="data.srcImg"
                        :list="data.list"
                        :checklist="data.checklist"
                        :prompts="data.prompt_group"
                        :page-id="$route.params.id"
                        :prompt-id="data.id_prompt"
                        :is-admin="data.clear"
                        unit-type="page"
                        :unit-id="$route.params.id"
                        :prompt="data.prompt"
                        :is-first-exercise="data.is_first"
                        :user-id="userId"
                        :module-id="module.id"
                        :course-id="course.id"
                        :course-name="course.name"
                        :is-mission="isMission"
                        :is-augmented="course.isAugmented"
                        :question="data.text"
                        :company-name="data.company"
                        :communityPosts="data.posts"
                        :community-user-post="data.user_post ? data.user_post : null"
                        :quiz-id="data.object_id"
                        :quizData="data.content"
                        :is-dark-bg="parseComponent !== 'prompt-group-horizontal' ? isDarkBg : false"
                        :id="id"
                    />
                </div>
            </div>
        </b-container>
    </div>
</template>

<script>
    import BlockHeader from "../../molecules/BlockHeader";
    import TextWithImageRight from "./blocks/TextWithImageRight";
    import ListWithImageLeft from "./blocks/ListWithImageLeft";
    import TextBlock from "./blocks/TextBlock";
    import AccordionGroup from "./blocks/AccordionGroup";
    import Quote from "./blocks/Quote";
    import WistiaVideo from "./blocks/WistiaVideo";
    import VideoWithAccordion from "./blocks/VideoWithAccordion";
    import VideoWithQuote from "./blocks/VideoWithQuote";
    import TwoColumns from "./blocks/TwoColumns";
    import PromptGroupHorizontal from "./PromptGroupHorizontal";
    import PromptGroup from "./PromptGroup";
    import SinglePrompt from "./blocks/SinglePrompt";
    import Checklist from "./blocks/Checklist";
    import CommunityLogBook from "../../templates/CommunityLogBook";
    import QuizContainer from "../QuizContainer";
    import MultiMeBlock from "../stream-page/blocks/MultiMeBlock";

    export default {
        name: "BlockContainer",
        components: {
            BlockHeader,
            TextWithImageRight,
            ListWithImageLeft,
            TextBlock,
            AccordionGroup,
            Quote,
            WistiaVideo,
            VideoWithAccordion,
            VideoWithQuote,
            TwoColumns,
            PromptGroupHorizontal,
            PromptGroup,
            SinglePrompt,
            Checklist,
            MultiMeBlock,
            QuizContainer,
            CommunityLogBook
        },
        props:{
            id: Number,
            type: String,
            data: Object,
            module: Object,
            course: Object,
            isMission: String,
            userId: Number,
            color: String
        },
        computed:{
            parseComponent(){
                let component = '';
                switch (this.type){
                    case 'two_cols':
                        component = 'two-columns';
                        break;
                    case 'text_simple':
                        component = 'text-block';
                        break;
                    case 'video_single':
                        component = 'wistia-video';
                        break;
                    case 'video_with_quote':
                        component = 'video-with-quote';
                        break;
                    case 'video_with_accordion':
                        component = 'video-with-accordion';
                        break;
                    case 'accordion':
                        component = 'accordion-group';
                        break;
                    case 'quote_single':
                        component = 'quote';
                        break;
                    case 'text_with_dx_image':
                        component = 'text-with-image-right';
                        break;
                    case 'prompt_group_horizontal':
                        component = 'prompt-group-horizontal';
                        break;
                    case 'prompt_group':
                        component = 'prompt-group';
                        break;
                    case 'prompt_single':
                        component = 'single-prompt';
                        break;
                    case 'text_with_sx_image_and_list':
                        component = 'list-with-image-left';
                        break;
                    case 'posts_collector':
                        component = 'community-log-book';
                        break;
                    case 'checklist':
                        component = 'checklist';
                        break;
                    case 'multicircle':
                        component = 'multi-me-block';
                        break;
                    case 'quiz':
                        component = 'quiz-container';
                        break;
                    default:
                        console.log(`component not implemented! ${this.type}`);
                        break;
                }
                return component;
            },
            isDarkBg(){
                return this.color === 'primary-block';
            }
        },
        methods:{
            transformQuoteData(data){
                return data.map(quote => {
                    return {quote: quote.contenuto, author_name: quote.name, author_title: quote.job}
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .block-top{
        padding-top: 80px;
    }

    .block-container{
        padding-bottom: 80px;
    }
</style>